
export const resolveText = (text: string) => {
    return text && text.split(/[-|_]/).join(" ");
  };
  
  export const resolveDate = (timestamp: string) => {
    const date = new Date(timestamp);
    return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
  };

  export const notBlank: <T>(value: T) => boolean = <T>(value: T): value is T =>
  !(
    typeof value === "undefined" ||
    value === null ||
    (typeof value === "string" ? value.length < 1 : false) ||
    (Array.isArray(value) ? value.length < 1 : false) ||
    (typeof value === "boolean" && value === false)
  );
  
export const formatApplicationType = (data: string) => {
    return data === "resource" ? "proxy" : data;
};
  